export function fractionToLatex(string) {
  const arr = string.split("/");
  if (arr[1] == "1") {
    return arr[0];
  } else {
    const latexFraction = "\\frac{" + arr[0] + "}{" + arr[1] + "}";
    return latexFraction;
  }
}
